<template>
  <basic-block :value="value" :mode="mode" :state.sync="state">
    <template v-slot:main>
      <ShapeControlHandle
        v-if="displayHandler"
        class="shape-arrow-90-deg-control-handler-x"
        :x="radius"
        :x-range="[0, Math.min(slope, height / 2 + thickBody / 2)]"
        :y="0"
        :angle="value.rotation"
        @update:x="x => (value.data.controls.radius = x / width / height)" />
      <ShapeControlHandle
        v-if="displayHandler"
        class="shape-arrow-90-deg-control-handler-x"
        :x="slope"
        :x-range="[width * 0.51, width]"
        :y="0"
        :angle="value.rotation"
        @update:x="updateSlope" />
      <ShapeControlHandle
        v-if="displayHandler"
        class="shape-arrow-90-deg-control-handler-y"
        :x="width"
        :y="thickHead"
        :y-range="[5, height]"
        :angle="value.rotation"
        @update:y="y => (value.data.controls.thickHead = y / height)" />
      <ShapeControlHandle
        v-if="displayHandler"
        class="shape-arrow-90-deg-control-handler-y"
        :x="thickBody"
        :x-range="[5, width * 0.49]"
        :y="height"
        :angle="value.rotation"
        @update:x="updateThickBody" />
      <svg
        class="shape-arrow-90-deg"
        style="vertical-align: top"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="100%"
        height="100%"
        preserveAspectRatio="none"
        :viewBox="`0 0 ${width} ${height}`">
        <defs>
          <path
            :id="`path-${id}`"
            :d="`
                M ${width} ${thickHead / 2}
                L ${slope} 0
                L ${slope} ${(thickHead - thickBody) / 2}
                L ${radius} ${(thickHead - thickBody) / 2}
                A ${radius} ${radius} 0 0 0 0 ${(thickHead - thickBody) / 2 + radius}
                L 0 ${(thickHead - thickBody) / 2 + radius}
                L 0 ${height}
                L ${thickBody} ${height}
                L ${thickBody} ${(thickHead + thickBody) / 2 + innerRadius}
                A ${innerRadius} ${innerRadius} 0 0 1 ${thickBody + innerRadius} ${(thickHead + thickBody) / 2}
                L ${thickBody + innerRadius} ${(thickHead + thickBody) / 2}
                L ${slope} ${(thickHead + thickBody) / 2}
                L ${slope} ${thickHead}
                L ${width} ${thickHead / 2}
              `"
            :style="value.data.style"
            stroke-linecap="round" />
          <clipPath :id="`clip-${id}`">
            <use :xlink:href="`#path-${id}`" />
          </clipPath>
        </defs>
        <g>
          <use :xlink:href="`#path-${id}`" :clip-path="`url(#clip-${id})`" />
        </g>
      </svg>
    </template>
  </basic-block>
</template>

<script>
import BasicBlock from "../_components/containers/BasicBlock.vue"
import ShapeControlHandle from "../_components/utils/ShapeControlHandle.vue"
import { BlockSelectionState } from "../_models/blockSelectionState";
export default {
  name: "BlockShapeArrow",
  components: {
    BasicBlock,
    ShapeControlHandle
  },
  data() {
    return {
      state: BlockSelectionState.notSelected
    }
  },
  props: ["value", "mode"],
  computed: {
    displayHandler() {
      return this.state == BlockSelectionState.primarySelected && this.mode === "edit"
    },
    id() {
      return this.value.id
    },
    width() {
      return this.value.size.width
    },
    height() {
      return this.value.size.height
    },
    radius() {
      return Math.min(this.value.data.controls.radius * this.width * this.height, this.slope, this.height / 2 + this.thickBody / 2)
    },
    innerRadius() {
      return Math.max(0, this.radius - this.thickBody)
    },
    slope() {
      return this.width * this.value.data.controls.slope
    },
    thickHead() {
      return this.value.size.height * this.value.data.controls.thickHead
    },
    thickBody() {
      return this.width * this.value.data.controls.thickBody
    }
  },
  methods: {
    updateSlope(value) {
      const slopePx = Math.round(value)
      this.value.data.controls.slope = slopePx / this.width
    },
    updateThickBody(value) {
      const thickBodyPx = Math.round(value)
      this.value.data.controls.thickBody = thickBodyPx / this.width
    },
    calculateSlopeOnArrowResize(newWidth, oldWidth) {
      const slopePx = this.value.data.controls.slope * oldWidth
      const distanceFromRight = oldWidth - slopePx
      const newSlopePercentage = (newWidth - distanceFromRight) / newWidth

      this.value.data.controls.slope = newSlopePercentage
    },
    calculateThickBodyOnArrowResize(newWidth, oldWidth) {
      const thickBodyPx = this.value.data.controls.thickBody * oldWidth
      const newThickBodyPercentage = thickBodyPx / newWidth

      this.value.data.controls.thickBody = newThickBodyPercentage
    }
  },
  watch: {
    width(newWidth, oldWidth) {
      if (!newWidth) return

      this.calculateSlopeOnArrowResize(newWidth, oldWidth)
      this.calculateThickBodyOnArrowResize(newWidth, oldWidth)
    }
  }
}
</script>
